export default "__VITE_ASSET__AbkOzSQf__"